import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export default graphql(
  gql`
    mutation RequestEmailCodeV2($input: RequestCodeInput!) {
      requestEmailCodeV2(input: $input) {
        success
        masked_email
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      requestEmailCodeV2: async (input, secretKey) => {
        return mutate({
          variables: { input },
          context: {
            headers: {
              secret_key: secretKey,
            },
          },
        });
      },
    }),
  }
);
